exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedor-tareas__cargando[data-v-027ba682]{display:flex;flex-direction:row;justify-content:center;align-content:center;padding:10px}.contenedor-tareas .titulo-tarjeta[data-v-027ba682]{color:grey}.contenedor-tareas .v-card__text[data-v-027ba682]{background-color:#f0f0f0}.contenedor-tareas .contenedor-card[data-v-027ba682]{cursor:pointer;margin:8px}.contenedor-tareas .contenedor-card__card[data-v-027ba682]{background-color:#fff}.contenedor-tareas .contenedor-card__card[data-v-027ba682]:hover{background-color:#f1f2f4e7}.contenedor-tareas .contenedor-card__card-subtitle[data-v-027ba682]{color:#f7a072}.contenedor-tareas .container-btn-expandir[data-v-027ba682]{position:relative;width:100%;text-align:right}.contenedor-tareas .btnExpandir[data-v-027ba682]{background-color:#4ac6e7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-027ba682","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/TimeLine/TimeLineTareas/TimeLineTareas.scss
// module id = 1109
// module chunks = 0